import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-calendar',
  templateUrl: './icon-calendar.component.html',
  styleUrls: ['./icon-calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCalendarComponent {}
